
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'PopupWarning',
})
export default class PopupWarning extends Vue {
  @Prop(Boolean) value!: boolean;
  @Prop(String) message!: string;
  @Prop({ default: () => {}, type: Function }) onOk: Function;

  onClose() {
    this.$emit('input', false);
    this.onOk();
  }
}
